/** Shared logical stage used by the original Seer SWF animations. */
export const SWF_STAGE_WIDTH = 960;
/**
 * SWF_STAGE_HEIGHT，供本模块相关规则使用。
 */
export const SWF_STAGE_HEIGHT = 560;
